import { render, staticRenderFns } from "./FabricKnitTypeIndex.vue?vue&type=template&id=331aad05&scoped=true&"
import script from "./FabricKnitTypeIndex.vue?vue&type=script&lang=js&"
export * from "./FabricKnitTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331aad05",
  null
  
)

export default component.exports